import { useState } from "react";
import { Textareawithsteroids } from "./EnvironmentReport";
import { HeaderShow } from "./ESGmain";
import './governancereport.css';
import '../index.css';
import './index.css';

const GovernanceReport = () => {
    const [showContent,setShowContent] = useState(false)
    return ( 
        <div className="governancereport mt-2">
            <DiversityAndEquality/>
            <StakeholderInclusion/>
            <RiskAndOpportunities/>
            <CompanyStructure/>
            <StateThisYear/>
            <Transparency/>
            <ActiveParticipation/>
            <HeaderShow text={"Your Governance Aim"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="col-md-11 mx-auto">
                <div className="esg__companyinfo__header mb-1 governanceaim">
                    <h6>What does your company passionately care about in this category ? Have you created a benchmark just for that? </h6>
                </div>
                <div className="esg__leader__value mt-2 p-5 pt-3 pb-3 governanceaim">
                    <Textareawithsteroids
                        maxLength={2300}
                        keyHighlight={"yourgovernanceaim"}
                    />
                        
                </div>
                </div>:null
            }
        </div>
     );
}

const DiversityAndEquality = () => {
    const [showContent,setShowContent] = useState(false)
    const board = "Does your company have a board? Y/N"
    const composition = "Composition:"
    const governanceagebreakdown = "Age breakdown of board members:"
    const governancegenderbreakdown = "Gender breakdown in board:"
    const equalvotes = "Does everyone, independent of share, have equal votes ?"
    const boarddiversity = "Minority diversity in the board?"
    const culturaldiversity = "Cultural diversity in the board?"
    return ( 
        <>
            <HeaderShow text={"Diversity & Equality in Governance"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__scopes">
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{board}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={board}
                                maxLength={1}
                                keyHighlight={"board"}
                                minHeight={"100px"}
                                placeholder={"Does your company have a Board? A sounding boards? Advisory Board?"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__highlight">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{composition}</h6>
                        </div> 
                        <div className="esg__highlight__value p-4 mb-1">
                            <Textareawithsteroids
                                question={composition}
                                maxLength={1200}
                                keyHighlight={"composition"}
                                minHeight={"160px"}
                                placeholder={"E.g. Shareholders:\nEmployee representative:\nStakeholder:\n\n Experts in their field (what fields are represented)?"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{governanceagebreakdown}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                minHeight={"100px"}
                                question={governanceagebreakdown}
                                maxLength={1200}
                                keyHighlight={"governanceagebreakdown"}
                                placeholder={"E.g. Up to 30: 1\n 30 - 49: 2\n 50+: 3"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{governancegenderbreakdown}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={governancegenderbreakdown}
                                maxLength={1200}
                                keyHighlight={"governancegenderbreakdown"}
                                placeholder={"E.g. Female: 20\n Male: 21\n Non-binary: 22 \nOther: 23"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{equalvotes}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={equalvotes}
                                maxLength={1200}
                                keyHighlight={"equalvotes"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{boarddiversity}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={boarddiversity}
                                maxLength={1200}
                                keyHighlight={"boarddiversity"}
                            />
                        </div>
                    </div>
                    <div className="esg__companyinfo__leader">
                        <div className="esg__companyinfo__header mb-2">
                            <h6>{culturaldiversity}</h6>
                        </div>
                        <div className="esg__leader__value p-4 mb-1">
                            <Textareawithsteroids
                                question={culturaldiversity}
                                maxLength={1200}
                                keyHighlight={"culturaldiversity"}
                            />
                        </div>
                    </div>
                </div>
                :null
            }
        </>
    )
}

const StakeholderInclusion = () => {
    const [showContent,setShowContent] = useState(false)
    const involvestakeholder = "How do you involve stakeholders?\nE.g. the categories of stakeholders you engage with, and how they are identifier; the purpose of the stakeholder engagement; how the organization seeks to ensure meaningful engagement with stakeholders."
    const consumerorganisation = "How do you collaborate with consumer organisations. Industry associations, other membership associations, and national or international advocacy organizations?"
    return ( 
        <>
            <HeaderShow text={"Stakeholder Inclusion"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{involvestakeholder}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={involvestakeholder}
                            maxLength={1200}
                            keyHighlight={"involvestakeholder"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{consumerorganisation}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={consumerorganisation}
                            maxLength={1200}
                            keyHighlight={"consumerorganisation"}
                        />
                    </div>
                </div>
                </div>:null
            }
        </>
    )
}

const RiskAndOpportunities = () => {
    const [showContent,setShowContent] = useState(false)
    const riskanalysis = "Have you made an enterprise risk analysis?"
    const swot = "What are the TW in a Swot analysis for the company?"
    const riskreview = 'Describe how you carry out risk review?'
    const securitymeasures = "What security measures do you have?"
    const knowledge = "What are the company's resources of knowledge?"
    const taxonomy = "Timeline for taxonomy alignment?"
    const anticorruption = "What is your anti-corruption policy?"
    const dataprotection ="What is your personal data protection and privacy policy?"
    const education = "What is company education and training policy?"
    const investments = "Description and analysis of company's financial investments"
    return ( 
        <>
            <HeaderShow text={"Risks & Opportunities"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__workplace">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{riskanalysis}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={riskanalysis}
                            maxLength={1200}
                            keyHighlight={"riskanalysis"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{swot}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={swot}
                            maxLength={1200}
                            keyHighlight={"swot"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{riskreview}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={riskreview}
                            maxLength={1200}
                            keyHighlight={"riskreview"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{securitymeasures}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={securitymeasures}
                            maxLength={1200}
                            keyHighlight={"securitymeasures"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{knowledge}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={knowledge}
                            maxLength={1200}
                            keyHighlight={"knowledge"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{taxonomy}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={taxonomy}
                            maxLength={1200}
                            keyHighlight={"taxonomy"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{anticorruption}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={anticorruption}
                            maxLength={1200}
                            keyHighlight={"anticorruption"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{dataprotection}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={dataprotection}
                            maxLength={1200}
                            keyHighlight={"dataprotection"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{education}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={education}
                            maxLength={1200}
                            keyHighlight={"education"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{investments}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={investments}
                            maxLength={1200}
                            keyHighlight={"investments"}
                        />
                    </div>
                </div>
                </div>:null
            }
        </>
    )
}

const CompanyStructure = () => {
    const [showContent,setShowContent] = useState(false)
    const concernrelation = "Describe concern relations"
    const businessmanagement = "Account for why the company have good business management?"
    return ( 
        <>
            <HeaderShow text={"Company Structure"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{concernrelation}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={concernrelation}
                            maxLength={1200}
                            keyHighlight={"concernrelation"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{businessmanagement}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={businessmanagement}
                            maxLength={1200}
                            keyHighlight={"businessmanagement"}
                        />
                    </div>
                </div>
                </div>:null
            }
        </>
    )
}

const StateThisYear = () => {
    const [showContent,setShowContent] = useState(false)
    const description = "Description of the company during the reporting year"
    const exclusion = "Which company activities are excluded from this report, if any?"
    return ( 
        <>
            <HeaderShow text={"Status This Year"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{description}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={description}
                            maxLength={1200}
                            keyHighlight={"description"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{exclusion}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={exclusion}
                            maxLength={1200}
                            keyHighlight={"exclusion"}
                        />
                    </div>
                </div>
                </div>:null
            }
        </>
    )
}

const Transparency = () => {
    const [showContent,setShowContent] = useState(false)
    const declaration = "Does your company follow any declarations, disclosures, and/or statements?"
    const certification = "What certifications, Iso, Environmental or other does the company have for products and services (including LCAs and EPD)."
    return ( 
        <>
            <HeaderShow text={"Transparency"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{declaration}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={declaration}
                            maxLength={1200}
                            keyHighlight={"declaration"}
                        />
                    </div>
                </div>
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>{certification}</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            question={certification}
                            maxLength={1200}
                            keyHighlight={"certification"}
                        />
                    </div>
                </div>
                </div>:null
            }
        </>
    )
}

const ActiveParticipation = () => {
    const [showContent,setShowContent] = useState(false)
    return ( 
        <>
            <HeaderShow text={"Active Participation"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
            {
                showContent ?
                <div className="esg__companyinfo__values esg__scopes">
                <div className="esg__companyinfo__leader">
                    <div className="esg__companyinfo__header mb-2">
                        <h6>Does your company follow any declarations, disclosures, and/or statements?</h6>
                    </div>
                    <div className="esg__leader__value p-4 mb-1">
                        <Textareawithsteroids
                            maxLength={1200}
                            keyHighlight={"governanceactiveparticipation"}
                        />
                    </div>
                </div>
                </div>:null
            }

            
        </>
    )
}
 
export default GovernanceReport;